import {ReactNode} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    title?: string;
    children?: ReactNode;
    cancelButton?: ReactNode;
    okButtonText?: string;
    cancelButtonText?: string;
    onCancel?: () => void;
    onConfirmation?: () => void;
}

export const ModalConfirmLayoutCentered = (props: IProps) => {
    const {title, children, cancelButton, okButtonText, cancelButtonText, onCancel, onConfirmation} = props;

    return (
        <div className={innerWrap}>
            {title && (
                <Text mb={1.5} variant="headline_3" align="center">
                    {title}
                </Text>
            )}

            {children && (
                <Text as="div" variant="body_copy_1" align="center">
                    {children}
                </Text>
            )}

            <div className={buttonsWrapper}>
                <Button variant="filled_primary" onClick={onConfirmation} className={buttonStyle}>
                    {okButtonText ?? "Potwierdzam"}
                </Button>
                {cancelButton || (
                    <Button variant="outlined_secondary" onClick={onCancel} className={buttonStyle}>
                        {cancelButtonText ?? "Anuluj"}
                    </Button>
                )}
            </div>
        </div>
    );
};

const innerWrap = css({
    position: "relative",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    py: "7",
    px: "2",

    md: {
        pt: "7",
        pb: "4",
        px: "4",
        borderRadius: "1"
    }
});

const buttonsWrapper = css({
    display: "flex",
    flexDirection: "column",
    mt: "3",
    gap: "2",

    md: {
        mt: "5",
        flexDirection: "row"
    }
});

const buttonStyle = css({
    width: "100%",
    md: {
        width: "auto",
        minWidth: "23rem"
    }
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    title?: string;
    children?: ReactNode;
    cancelButton?: ReactNode;
    okButtonText?: string;
    cancelButtonText?: string;
    onCancel?: () => void;
    onConfirmation?: () => void;
}

export const ModalConfirmLayoutCentered = (props: IProps) => {
    const {title, children, cancelButton, okButtonText, cancelButtonText, onCancel, onConfirmation} = props;

    return (
        <div className={innerWrap}>
            {title && (
                <Text mb={1.5} variant="headline_3" align="center">
                    {title}
                </Text>
            )}

            {children && (
                <Text as="div" variant="body_copy_1" align="center">
                    {children}
                </Text>
            )}

            <div className={buttonsWrapper}>
                <Button variant="filled_primary" onClick={onConfirmation} className={buttonStyle}>
                    {okButtonText ?? "Potwierdzam"}
                </Button>
                {cancelButton || (
                    <Button variant="outlined_secondary" onClick={onCancel} className={buttonStyle}>
                        {cancelButtonText ?? "Anuluj"}
                    </Button>
                )}
            </div>
        </div>
    );
};

const innerWrap = css({
    position: "relative",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    py: "7",
    px: "2",

    md: {
        pt: "7",
        pb: "4",
        px: "4",
        borderRadius: "1"
    }
});

const buttonsWrapper = css({
    display: "flex",
    flexDirection: "column",
    mt: "3",
    gap: "2",

    md: {
        mt: "5",
        flexDirection: "row"
    }
});

const buttonStyle = css({
    width: "100%",
    md: {
        width: "auto",
        minWidth: "23rem"
    }
});
